import React, { useState, useEffect, useCallback } from 'react';
import moment from 'moment';
import './styles.css';

// function DayEventSelector({ stateId, selectedSite, selectedSiteName }) {
function DayEventSelector({ stateId, selectedSite, selectedSiteName, month, year }) {
    // const [selectedDate, setSelectedDate] = useState('');
    const [events, setEvents] = useState([]);
    // const [selectedImageUrl, setSelectedImageUrl] = useState('');
    // const [month, setMonth] = useState('');
    // const [day, setDay] = useState('');

    //const baseUrl = 'http://127.0.0.1:8000'; // use this if developing locally without using docker, ngrok, or prod enviornments
    const baseUrl = process.env.REACT_APP_API_BASE_URL; //this url should be of load balancer in AWS ECS and http://0.0.0.0:8000 for local

    // const handleEventChange = useCallback((eventId) => {
    //     setSelectedDate(eventId);
        
// <<<<<<< matlab-scripts
    //     if (stateId && selectedSite && eventId) {
    //         fetch(`${baseUrl}/api/states/${stateId}/sites/${selectedSite}/day_events/${eventId}`)
    //             .then(response => response.json())
    //             .then(data => {
    //                 if (data && data.detected_event && data.date) {
    //                     // setSelectedImageUrl(baseUrl + data.detected_event);
    //                     setSelectedImageUrl(data.detected_event);
    //                     const month = moment(data.date).format('MMMM');
    //                     const day = moment(data.date).format('DD');  // Corrected to 'DD' for day of the month
    //                     setMonth(month);
    //                     setDay(day);
    //                 }
    //                 else{
    //                     setSelectedImageUrl('');
    //                     setMonth('');
    //                     setDay('');
    //                 }
    //             })
    //             .catch(error => console.error('Error fetching detected event:', error));
    //     }
    // }, [stateId, selectedSite]);

    // useEffect(() => {
    //     if (stateId && selectedSite) {
    //         fetch(`${baseUrl}/api/states/${stateId}/sites/${selectedSite}/day_events/`)
    //             .then(response => response.json())
    //             .then(data => {
    //                 setEvents(data);
    //                 if (data.length > 0) {
    //                     const firstEventId = data[0].id;
    //                     setSelectedDate(firstEventId);
    //                     const selectedData = data.find(item => item.id === data[0].id);
    //                     const month = moment(selectedData.date).format('MMMM');
    //                     const day = moment(selectedData.date).format('DD');
    //                     setMonth(month);
    //                     setDay(day);
    //                     handleEventChange(firstEventId);
    //                 }
    //                 else {
    //                     setSelectedDate('');
    //                     setSelectedImageUrl('');
    //                     setMonth('');
    //                     setDay('');
    //                 }
    //             })
    //             .catch(error => console.error('Error fetching events:', error));
    //     }
    // }, [stateId, selectedSite, handleEventChange]);

    // return (
    //     <div className="site-day-dropdown">
    //         <div className="heading-button-day-displays">
    //             <h2>Month: {month}</h2>
    //             <h2>Day: {day}</h2>
    //         </div>
    //         {/* <br /> */}
    //         {/* <br /> */}
    //         {/* <br /> */}
    //         <div className="day-container">
    //             <div className="day-dropdown">
    //                 <select value={selectedDate} onChange={(e) => handleEventChange(e.target.value)}>
    //                     <option value="">Select the Date</option>
    //                     {events.map(event => (
    //                         <option key={event.id} value={event.id}>
    //                             {moment(event.date).format('DD MMMM YYYY')}
    //                         </option>
    //                     ))}
    //                 </select>
    //                 <br />
    //                 <br />
    //             </div>
    //             <div className="max-image">
    //                 {selectedImageUrl && <img src={selectedImageUrl} alt="Event" className="max-height-image" />}
    //             </div>
    //         </div>
    //     </div>
    // );
// =======
//         if (stateId && selectedSite && eventId) {
//             fetch(`${baseUrl}/api/states/${stateId}/sites/${selectedSite}/day_events/${eventId}/`)
//                 .then(response => response.json())
//                 .then(data => {
//                     if (data && data.detected_event && data.date) {
//                         setSelectedImageUrl(baseUrl + data.detected_event);
//                         // setSelectedImageUrl(data.detected_event);
//                         const month = moment(data.date).format('MMMM');
//                         const day = moment(data.date).format('DD');  // Corrected to 'DD' for day of the month
//                         setMonth(month);
//                         setDay(day);
//                     }
//                     else{
//                         setSelectedImageUrl('');
//                         setMonth('');
//                         setDay('');
//                     }
//                 })
//                 .catch(error => console.error('Error fetching detected event:', error));
//         }
//     }, [stateId, selectedSite]);
// >>>>>>> noAWS

    useEffect(() => {
        if (stateId && selectedSite && month && year) {
            fetch(`${baseUrl}/api/states/${stateId}/sites/${selectedSite}/day_events/`)
                .then(response => response.json())
                .then(data => {
                    if (data && data.length > 0) {
                        // Sort events by date in descending order
                        // const sortedEvents = data.sort((a, b) => new Date(b.date) - new Date(a.date));

                        // Filter the events based on the passed month and year
                        const filteredEvents = data.filter(event => {
                            const eventDate = moment(event.date);
                            return (
                                eventDate.format('MMMM') === month &&
                                eventDate.year() === parseInt(year, 10)
                            );
                        });

                        // Sort the filtered events by date in descending order
                        const sortedEvents = filteredEvents.sort(
                            (a, b) => new Date(b.date) - new Date(a.date)
                        );
                        // Take the first 4 events (or fewer if less exist)
                        setEvents(sortedEvents.slice(0, 4));
                    } else {
                        setEvents([]);
                    }
                })
                .catch(error => console.error('Error fetching events:', error));
        }
    }, [stateId, selectedSite, selectedSiteName, month, year, baseUrl]);

    return (
        <div className="site-date-dropdown">
            <div className="heading-button-day-displays">
                {/* <h2>Selected year: {year}</h2>
                <h2>Month: {month}</h2>
                <h2>location: {selectedSiteName}</h2> */}
                <p>
                    The following 4-or-5 plots show weekly (test-statistic-over-threshold) curves using the same color-code 
                    <br />
                    as in the above monthly plots. The objective is to further analyze the temporal profile of interference events:
                    <br />
                    <br />
                </p>
            </div>
            <div className="day-container">
                {events.map((event, index) => (
                    <div key={index} className="max-image">
                        {/* <h3>{moment(event.date).format('DD MMMM YYYY')}</h3> */}
                        {event.detected_event && (
                            <img 
                                src={baseUrl + event.detected_event} 
                                alt={`Event on ${moment(event.date).format('DD MMMM YYYY')}`} 
                                className="max-height-image" 
                            />
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default DayEventSelector;
